var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 138,
    height: 86.187,
    viewBox: "0 0 138 86.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 50.723,
    height: 64.176,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tIME_OUT",
    "data-name": "tIME OUT",
    transform: "translate(-782 -330.813)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 69,
    cy: 5.5,
    rx: 69,
    ry: 5.5,
    transform: "translate(782 406)",
    fill: "#daf4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(843.247 333.09) rotate(21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(-1.048 -2.036)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M14.275,5.311h23.45a5.382,5.382,0,0,1,5.365,5.365v9.709a5.381,5.381,0,0,1-5.365,5.364h-2.74a5.991,5.991,0,1,0,0,11.981h2.74a5.381,5.381,0,0,1,5.365,5.364V52.8a5.382,5.382,0,0,1-5.365,5.365H14.275A5.381,5.381,0,0,1,8.91,52.8V43.093a5.38,5.38,0,0,1,5.365-5.364h2.74a5.991,5.991,0,1,0,0-11.981h-2.74A5.38,5.38,0,0,1,8.91,20.384V10.676a5.381,5.381,0,0,1,5.365-5.365",
    transform: "translate(-0.639 -0.381)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M14.162,3.738h23.45a6.841,6.841,0,0,1,6.825,6.825v9.709A6.841,6.841,0,0,1,37.612,27.1h-2.74a4.53,4.53,0,0,0,0,9.06h2.74a6.843,6.843,0,0,1,6.825,6.825v9.709a6.843,6.843,0,0,1-6.825,6.825H14.162a6.841,6.841,0,0,1-6.824-6.825V42.98a6.841,6.841,0,0,1,6.824-6.825H16.9a4.53,4.53,0,0,0,0-9.06h-2.74a6.84,6.84,0,0,1-6.824-6.824V10.563a6.84,6.84,0,0,1,6.824-6.825m23.45,2.921H14.162a3.919,3.919,0,0,0-3.9,3.9v9.709a3.919,3.919,0,0,0,3.9,3.9H16.9a7.45,7.45,0,0,1,0,14.9h-2.74a3.919,3.919,0,0,0-3.9,3.9v9.709a3.918,3.918,0,0,0,3.9,3.9h23.45a3.918,3.918,0,0,0,3.9-3.9V42.98a3.919,3.919,0,0,0-3.9-3.9h-2.74a7.45,7.45,0,0,1,0-14.9h2.74a3.919,3.919,0,0,0,3.9-3.9V10.563a3.919,3.919,0,0,0-3.9-3.9",
    transform: "translate(-0.526 -0.268)",
    fill: "#1a315d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M3.78,65.335H47.169a2.214,2.214,0,0,0,2.207-2.207V59.135a2.214,2.214,0,0,0-2.207-2.208H3.78a2.214,2.214,0,0,0-2.208,2.208v3.994A2.214,2.214,0,0,0,3.78,65.335",
    transform: "translate(-0.113 -4.08)",
    fill: "#c4c4c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M49.376,62.413v-3.28a2.214,2.214,0,0,0-2.207-2.207H3.78a2.214,2.214,0,0,0-2.208,2.207v3.28Z",
    transform: "translate(-0.113 -4.08)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M10.508,53.609h31.21a3.6,3.6,0,0,0,.024-.426V43.474a3.921,3.921,0,0,0-3.9-3.9H35.1a7.451,7.451,0,0,1,0-14.9h2.74a3.919,3.919,0,0,0,3.9-3.9V11.056a3.6,3.6,0,0,0-.024-.426H10.508a3.6,3.6,0,0,0-.023.426v9.709a3.918,3.918,0,0,0,3.9,3.9h2.74a7.451,7.451,0,0,1,0,14.9h-2.74a3.919,3.919,0,0,0-3.9,3.9v9.709a3.6,3.6,0,0,0,.023.426",
    transform: "translate(-0.751 -0.762)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M3.78,1.573H47.169A2.213,2.213,0,0,1,49.376,3.78V7.773a2.214,2.214,0,0,1-2.207,2.208H3.78A2.214,2.214,0,0,1,1.572,7.773V3.78A2.213,2.213,0,0,1,3.78,1.573",
    transform: "translate(-0.113 -0.113)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M3.667,65.335H47.056a.753.753,0,0,0,.745-.746V60.594a.753.753,0,0,0-.745-.746H3.667a.751.751,0,0,0-.746.746v3.995a.751.751,0,0,0,.746.746m43.389,2.921H3.667A3.672,3.672,0,0,1,0,64.589V60.594a3.672,3.672,0,0,1,3.667-3.667H47.056a3.672,3.672,0,0,1,3.666,3.667v3.995a3.672,3.672,0,0,1-3.666,3.667",
    transform: "translate(0 -4.08)",
    fill: "#1a315d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M3.667,0H47.056a3.672,3.672,0,0,1,3.666,3.667V7.662a3.674,3.674,0,0,1-3.666,3.668H3.667A3.674,3.674,0,0,1,0,7.662V3.668A3.672,3.672,0,0,1,3.667,0m43.389,2.92H3.667a.751.751,0,0,0-.746.747V7.662a.75.75,0,0,0,.746.745H47.056a.751.751,0,0,0,.745-.745V3.668a.753.753,0,0,0-.745-.747",
    transform: "translate(0 0)",
    fill: "#1a315d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M10.45,8.633H47.283a.753.753,0,0,0,.745-.746V3.893a.751.751,0,0,0-.745-.746H3.893a.75.75,0,0,0-.746.746V7.887a.751.751,0,0,0,.746.746H10.45Z",
    transform: "translate(-0.226 -0.226)",
    fill: "#c4c4c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M48.027,5.89v-2a.75.75,0,0,0-.745-.746H3.892a.751.751,0,0,0-.746.746v2Z",
    transform: "translate(-0.225 -0.226)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M41.741,12.2H10.484v8.674a3.918,3.918,0,0,0,3.9,3.9h2.74a7.451,7.451,0,0,1,0,14.9h-2.74a3.919,3.919,0,0,0-3.9,3.9V53.722H41.741V43.587a3.919,3.919,0,0,0-3.9-3.9H35.1a7.451,7.451,0,0,1,0-14.9h2.74a3.918,3.918,0,0,0,3.9-3.9Z",
    transform: "translate(-0.751 -0.875)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M26.32,38.828a10.172,10.172,0,0,1-8.985,5.451H14.6A1.23,1.23,0,0,0,13.379,45.5v5.988H39.261V45.5a1.23,1.23,0,0,0-1.216-1.216h-2.74a10.176,10.176,0,0,1-8.985-5.451",
    transform: "translate(-0.959 -2.783)",
    fill: "#63ace1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M13.379,19.494V21.4A1.233,1.233,0,0,0,14.6,22.617h2.74a10.162,10.162,0,0,1,8.984,5.451,10.172,10.172,0,0,1,8.985-5.451h2.74A1.233,1.233,0,0,0,39.262,21.4V19.494Z",
    transform: "translate(-0.959 -1.397)",
    fill: "#63ace1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M27.233,50.219a1.113,1.113,0,1,0-1.112-1.113,1.115,1.115,0,0,0,1.112,1.113",
    transform: "translate(-1.872 -3.44)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M22.305,50.219a1.113,1.113,0,1,0-1.112-1.113,1.115,1.115,0,0,0,1.112,1.113",
    transform: "translate(-1.519 -3.44)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M32.162,50.219a1.113,1.113,0,1,0-1.113-1.113,1.116,1.116,0,0,0,1.113,1.113",
    transform: "translate(-2.225 -3.44)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M29.7,47.289a1.113,1.113,0,1,0-1.112-1.113A1.115,1.115,0,0,0,29.7,47.289",
    transform: "translate(-2.049 -3.23)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M24.769,47.289a1.113,1.113,0,1,0-1.113-1.113,1.116,1.116,0,0,0,1.113,1.113",
    transform: "translate(-1.695 -3.23)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeOut);
export default __webpack_public_path__ + "static/media/TimeOut.4b2c8e08695faf02aec9ec4c56af7c3d.svg";
export { ForwardRef as ReactComponent };